<template lang="pug">
  .option-wrapper
    RadioSlider.slider(
      :items="optionsData.items",
      :current="optionsData.items.findIndex(i => i.id === optionsData.selected.id)",
      @selected="onSelectOption"
    )

    template(v-if="optionsData.selected.id === 'delete_abstract_justify'")
      PButton(size="md" block color="danger" @click="save" :loading="saving")
        | remover dispensas, suspensões e observações

    template(v-else)
      PSelect(
        labelItem="description",
        v-model="reason",
        useCommon="reasons"
        title="motivo"
      )

      template(v-if="optionsData.selected.id === 'justify'")
        PCheckbox(label="considerar como horas trabalhadas", v-model="hoursAreWork")
        PCheckbox(label="descontar dispensa nas horas da jornada do dia", v-model="hoursAreNothing")
        PCheckbox(label="considerar como falta", v-model="isFalta")
        PCheckbox(label="ignorar jornadas de folga", v-model="ignoreFolga")

      template(v-else-if="optionsData.selected.id === 'justified_absence'")
        PCheckbox(label="descontar DSR", v-model="isDSR")
        PCheckbox(label="considerar como falta", v-model="isFalta")

      PButton(size="md" block color="success" @click="save" :loading="saving") salvar

</template>

<script>
import {formatDateToSend} from 'src/utils'
import moment from 'moment'

export default {
  name: 'Justifies',
  props: {
    saveParams: {type: Object, required: true},
    options: {type: Array, required: true}
  },
  created () {
    this.optionsData.items = this.options
    this.optionsData.selected = this.options[0]
  },
  data () {
    return {
      optionsData: {
        selected: null,
        items: []
      },
      reason: {
        selected: null
      },
      hoursAreWork: false,
      hoursAreNothing: false,
      isFalta: false,
      isDSR: false,
      saving: false,
      ignoreFolga: false
    }
  },
  methods: {
    async save () {
      this.saving = true

      try {
        const result = await this.$API.fastRegister.save({
          ...this.saveParams,
          option: this.optionsData.selected.id,
          extra: this.getExtraPerOption()
        })
        this.$checkUserFiles()
        this.$swal({
          type: 'success',
          text: result.data?.success ? result.data.success : 'Mudanças aplicadas com sucesso'
        })
      } catch (e) {
        this.$swal({
          type: 'error',
          text: e.data?.error ? e.data.error : 'Não foi possivel aplicar as mudanças'
        })
      }

      this.saving = false
    },
    getExtraPerOption () {
      if (this.optionsData.selected.id === 'justify') {
        const today = moment().startOf('day')

        return {
          // idk why back required startTime and endTime or why we send this way. i just copied from angular
          startTime: formatDateToSend(today.add(8, 'hours')),
          endTime: formatDateToSend(today.add(18, 'hours')),
          loseDsr: false,
          reason: this.reason.selected,
          allDay: true,
          isFalta: this.isFalta,
          hoursAreWork: this.hoursAreWork,
          hoursAreNothing: this.hoursAreNothing,
          ignore_folga: this.ignoreFolga
        }
      } else if (this.optionsData.selected.id === 'justified_absence') {
        return {
          reason: this.reason.selected,
          isFault: this.isFalta,
          isDSR: this.isDSR
        }
      } else if (this.optionsData.selected.id === 'delete_abstract_justify') {
        return {}
      } else if (this.optionsData.selected.id === 'suspension') {
        return {
          reason: this.reason.selected
        }
      }
    },
    onSelectOption (item) {
      this.optionsData.selected = item
    }
  }
}
</script>

<style scoped lang="scss">
.option-wrapper {
  display: grid;
  grid-row-gap: 10px;
  padding-top: 20px;
}
</style>
